/*global SPiD*/
(function (_) {
    'use strict';

    var iframe = document.getElementsByTagName('iframe')[0] || false;

    window.addEventListener('message', function(event) {
        _.sizeFitIframe(iframe, event.data);
    });

    SPiD.autoDisplay(document.body, SPiD.i18n);
}(SPiD));
